import { gql } from "@apollo/client/core";

export default gql`
    mutation DeletePlace($id: ID!) {
        deleteLocal(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`
